import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeesClient, FinancialDetailsDto } from '@services';
import { DxLoadPanelModule } from 'devextreme-angular';
import { EmploymentDetailRowComponent } from '../employment-detail-row/employment-detail-row.component';

@Component({
    selector: 'app-financial-details',
    templateUrl: './financial-details.component.html',
    standalone: true,
    imports: [CommonModule, DxLoadPanelModule, EmploymentDetailRowComponent]
})
export class FinancialDetailsComponent implements OnInit {
    private employeesClient = inject(EmployeesClient);

    @Input() userId: string;

    financialData: FinancialDetailsDto;
    isLoading = false;

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        if (!this.userId) return;
        this.isLoading = true;
        this.employeesClient.getFinancialDetails(this.userId).subscribe({
            next: (data) => {
                this.financialData = data;
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
            }
        });
    }
}

